<fieldset>
 <legend>
  TypeCPVClass
 </legend>
 <button class="btn btn-outline-primary" (click)="addclassSupplementaire()">Ajouter un classSupplementaire</button>
<div *ngFor="let obj of objetPrincipal.classSupplementaire; let i = index">
  <fieldset>
    <legend>
      classSupplementaire {{ i + 1}}
    </legend>
    <button class="btn btn-outline-primary" (click)="removeclassSupplementaire(i)">Supprimer un classSupplementaire</button>
    <app-form-input
	[parentForm]="parentForm"
	[value]="obj"
	
	[label]="'classSupplementaire'"
	[type]="'text'" [rule]="'pattern_15'"
	[name]="getUid()+'_index_'+(i+1)+'_SepAtt_classSupplementaire'">
	</app-form-input>
  </fieldset>
</div>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="objetPrincipal.classPrincipale"

[label]="'classPrincipale'"
[type]="'text'" [rule]="'pattern_17'"
[name]="getUid()+'_SepAtt_classPrincipale'">
</app-form-input>
</fieldset>
